module.exports = __webpack_public_path__ + "static/img/4.aabbda7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/four/4.png
// module id = fknQ
// module chunks = 1